import { connect } from 'react-redux'
import MaintenanceAuditTargetComponent from '../components/MaintenanceAuditTargetComponent.jsx';
import {
    forwardToFindAuditableDetails,
    forwardToAuditDetail,
	forwardToRefixDetail,
	forwardToCompleteAudit,
	forwardToExpandMenuMax
} from '../actions';

const mapStateToProps = (state) => ({
	request: state.getIn(['maintenanceAuditingReducer', 'request']),
	response: state.getIn(['maintenanceAuditingReducer', 'response']),
	options: state.getIn(['maintenanceAuditingReducer', 'options']),
    alert: state.getIn(['alertReducer', 'alert']),
})

const mapDispatchToProps = (dispatch) => ({

    findAuditableDetails: (cardPk, type) => {
		dispatch(forwardToFindAuditableDetails(cardPk, type));
    },

	detailAudited: (detail, card, type, auditor)=>{
		dispatch(forwardToAuditDetail(detail, card, type, auditor));
	},

	backToFixing: (detail, card, type)=>{
		dispatch(forwardToRefixDetail(detail, card, type));
	},

	completeAudit: (card, type, auditor) => {
		dispatch(forwardToCompleteAudit(card, type, auditor));
	},

	expandContent: () => {
		dispatch(forwardToExpandMenuMax());
	},
})

const MaintenanceAuditTargetContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceAuditTargetComponent)

export default MaintenanceAuditTargetContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceAuditTargetContainer.jsx